import { Body, Button, Heading } from "@elaniintc/goes-design-system";
import React from "react";
import { NodeCardsList } from "./node-cards-list";
import type { NodeExecutionType } from "@/types/entities/flows";
import type { FormalityRequestType } from "@/types/entities/formality-request";
import { Skeleton } from "@/components/ui/skeleton";

interface ActionNodeListProps {
  hidden?: boolean;
  isLoading?: boolean;
  showNodeSkeleton?: boolean;
  nodes?: Array<NodeExecutionType>;
  procedureId: string;
  formalityRequest?: FormalityRequestType;
}

export const ActionNodeList = ({
  isLoading,
  showNodeSkeleton,
  nodes = [],
  hidden,
  procedureId,
  formalityRequest,
}: ActionNodeListProps) => {
  const [showAllNodes, setShowAllNodes] = React.useState(false);
  const shouldShowToggle = nodes.length > 2;
  const visibleNodes =
    shouldShowToggle && !showAllNodes ? nodes.slice(0, 2) : nodes;

  if (hidden) return null;

  const renderNodeList = () => {
    if (isLoading && showNodeSkeleton) {
      return <Skeleton className="h-18 w-full rounded-md shrink-0" />;
    }

    if (nodes.length > 0) {
      return (
        <div className="flex flex-col gap-2 w-full">
          <NodeCardsList
            nodes={visibleNodes}
            procedureId={procedureId}
            formalityRequest={formalityRequest}
            startIndex={0}
          />

          {shouldShowToggle && (
            <Button
              variant={"ghost"}
              type="button"
              size={"xs"}
              onClick={() => setShowAllNodes((prev) => !prev)}
            >
              {showAllNodes ? "Ver menos" : "Ver más"}
            </Button>
          )}
        </div>
      );
    }

    // empty state
    return (
      <div className="flex justify-center border border-neutral-object-accent-quiet h-18 items-center gap-3 p-4 rounded-lg bg-neutral-object-accent-quiet">
        {!showNodeSkeleton && (
          <Heading variant="h6" color="quiet">
            No tiene acciones pendientes actualmente
          </Heading>
        )}
      </div>
    );
  };

  return (
    <div className="flex flex-col gap-3 bg-neutral-object-accent-quiet px-3 pt-3 pb-2 rounded-lg">
      <div>
        <Heading variant="h6" className="text-heading">
          Próximos pasos clave
        </Heading>
        <Body className="text-body-quiet text-sm mt-1">
          Estos pasos requieren de su intervención para continuar el trámite.
        </Body>
      </div>

      {renderNodeList()}
    </div>
  );
};
